import { useEffect } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { AuthProvider } from './context/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'
import ScrollToTop from './components/ScrollToTop'
import { PWAInstallProvider, usePWAInstall } from './context/PWAInstallContext'

function PWAInstallCapture() {
  const { setDeferredPrompt } = usePWAInstall()
  useEffect(() => {
    const handler = e => { e.preventDefault(); setDeferredPrompt(e) }
    window.addEventListener('beforeinstallprompt', handler)
    return () => window.removeEventListener('beforeinstallprompt', handler)
  }, [setDeferredPrompt])
  return null
}
import Landing from './pages/Landing'
import Pricing from './pages/Pricing'
import Login from './pages/Login'
import Signup from './pages/Signup'
import Dashboard from './pages/Dashboard'
import SetupAccount from './pages/SetupAccount'
import ConfirmPassword from './pages/ConfirmPassword'
import About from './pages/About'
import Reviews from './pages/Reviews'
import PrivacyPolicy from './pages/PrivacyPolicy'
import Demo from './pages/Demo'
import ResetPassword from './pages/ResetPassword'

export default function App() {
  return (
    <PWAInstallProvider>
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <PWAInstallCapture />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/setup-account" element={<SetupAccount />} />
          <Route path="/confirm-password" element={<ConfirmPassword />} />
          <Route path="/about" element={<About />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/demo" element={<Demo />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
    </PWAInstallProvider>
  )
}